import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StorageService } from '../service/storage.service';

/**
 * Protege rutas exclusivas de administrador (por ahora, "/principal/usuario").
 * Complementa a AuthGuard: ese guard solo garantiza que hay sesión iniciada;
 * este además exige rol "administrador". Antes el único control era ocultar
 * el link en el menú con "*ngIf=esAdministrado" (ver menu.component.html /
 * generarqr.component.html), pero la ruta en sí quedaba abierta: cualquier
 * usuario autenticado que escribiera la URL a mano podía ver el listado
 * completo de usuarios y sus correos.
 */
@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private storageService: StorageService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.storageService.esAdministrador()) {
      return true;
    }

    // Con sesión pero sin permiso: se manda al dashboard, no a /login
    // (ya está autenticado, solo no tiene acceso a esta pantalla).
    return this.router.createUrlTree(['/principal/menu']);
  }
}
